/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-28 17:50:13
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-29 13:49:14
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/myActivities/list/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';

function getColums(instance){
    let arr = [
        {
            label: '活动信息',
            minWidth: '196',
            type: () => import('./components/tableCell/activityCell.vue'),
            isShow: true,
        },
        {
            label: '团长信息',
            minWidth: '220',
            type: () => import('./components/tableCell/leaderInfoCell.vue'),
            isShow: true,
        },
        {
            label: '活动报名状态',
            minWidth: '120',
            isShow: true,
            platformId: instance.platformId,
            type: () => import('./components/tableCell/activityStatusCell.vue'),
        },
        {
            key: 'apply_start_time',
            label: '报名时间',
            minWidth: '180',
            type: ColumnTypes.TextCell,
            isShow: instance.$isDy(instance.platformId),
        },
        {
            key: 'activity_type_name',
            label: '活动类型',
            minWidth: '120',
            type: ColumnTypes.TextCell,
            isShow: instance.$isKs(instance.platformId),
        },
        {
            label: '活动时间',
            minWidth: '120',
            type: () => import('./components/tableCell/activityTimeCell.vue'),
            isShow: instance.$isKs(instance.platformId),
        },
        {
            label: '商品数',
            minWidth: '100',
            type: () => import('./components/tableCell/goodsCountCell.vue'),
            isShow: instance.$isKs(instance.platformId),
        },
        {
            key:'operations',
            label: '操作',
            minWidth: '160',
            type: ColumnTypes.ButtonsCell,
            isShow: true,
        },


    ];
    return  arr.filter((item) => item.isShow );
}

export default getColums